import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDeleteSubitemsMutation = () =>
  useTypedMutation({
    mutationFn: (intervention_element_id: number) => ApiInstance.post("/interventions/element/delete", { intervention_element_id }),
    onSuccess: intervention_element_id => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.interventions?.length) return;

      const interventionIdx = appointment.interventions.findIndex(intervention => intervention.elements?.some(element => element.id === intervention_element_id));
      if (interventionIdx < 0 || !appointment.interventions[interventionIdx].elements?.length) return;

      const elementIdx = appointment.interventions[interventionIdx].elements.findIndex(e => e.id === intervention_element_id);
      if (elementIdx < 0) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
        ...appointment,
        interventions: appointment.interventions.with(interventionIdx, {
          ...appointment.interventions[interventionIdx],
          elements: appointment.interventions[interventionIdx].elements.toSpliced(elementIdx, 1)
        })
      });
    }
  });
